import { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { LegalFooter } from "./LegalFooter";

export function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        bgcolor: "background.default",
      }}
    >
      {/* Own row: avoids TopBar sitting beside main in a row flex (breaks mobile / devtools) */}
      <TopBar onMenuClick={() => setMobileOpen(true)} />
      <Box
        sx={{
          display: "flex",
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          width: "100%",
        }}
      >
        <Sidebar
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
        <Box
          component="main"
          sx={{
            flex: "1 1 auto",
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            bgcolor: "background.default",
          }}
        >
          <Toolbar sx={{ display: { lg: "none" } }} />
          <Box
            sx={{
              flex: "1 1 auto",
              minWidth: 0,
              width: "100%",
            }}
          >
            <Outlet />
          </Box>
          <LegalFooter />
        </Box>
      </Box>
    </Box>
  );
}
